export enum DoorType {
  LOCATION_FROM = 'From',
  LOCATION_TO = 'To',
}
